// extracted by mini-css-extract-plugin
export var container = "index-module--container--e6852";
export var loadingText = "index-module--loadingText--51e4c";
export var loadingWave = "index-module--loadingWave--98372";
export var main = "index-module--main--170f9";
export var mobile = "index-module--mobile--fc2d2";
export var prepare = "index-module--prepare--5312d";
export var prepareReady = "index-module--prepareReady--f0ddb";
export var ready = "index-module--ready--08dcf";